import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { logoutUser } from '../../actions/userActions'
import { applyFilter, showPopup, applyTagsFilter } from '../../actions/uiActions'
import Select from 'react-select'
import { getTags } from '../../actions/presentationActions'
import { withRouter } from '../../actions/withRouterHook'

class TagsSelect extends React.Component {
    state = {
        globalSearch: "",
        selectedOptions: null,
    }

    componentDidMount() {
        if (Object.keys(this.props.tagsList).length === 0) {
            this.props.getTags()
        }
    }

    handleChange = (options) => {
        this.setState({ selectedOptions: options });
        this.props.applyTagsFilter(options)
    }

    customStyles = {
        container: (provided, state) => ({
        }),
        control: () => ({
            width: "100%",
            height: 70,
            display: 'flex',
        }),
        option: (provided, state) => ({
            ...provided,
            textAlign: 'right',
            color: "black"
        }),
        valueContainer: (provided, state) => ({
            ...provided,
            padding: "1px 8px",
        }),
        multiValue: (provided, state) => ({
            ...provided,
            margin: "1px",
        }),
        multiValueLabel: (provided, state) => ({
            ...provided,
            paddingTop: "1px",
            paddingBottom: "1px",
            color: "black"
        }),
        menu: (provided, state) => ({
            ...provided,
            width: state.selectProps.width,
            display: 'flex',
        }),
        singleValue: (provided, state) => {
            const opacity = state.isDisabled ? 0.5 : 1;
            const transition = 'opacity 300ms';

            return { ...provided, opacity, transition };
        }
    }

    customTheme = (theme) => ({
        ...theme,
        colors: {
            ...theme.colors,
            text: 'orangered',
            primary: 'black',
            neutral20: '#ACB4BD', //Default arrow and |
            neutral50: '#ACB4BD', //Default text
            neutral60: 'white', //Arrow, |, and x when something is selected
            neutral80: 'gray', //Highlighted text, typed text, cursor, and x and arrow buttons
            neutral40: 'gray', //Arrow when dropdown is clicked but nothing is selected
        },
    })

    render() {
        if (this.props.loggedIn) {
            return (
                <Select
                    defaultValue={this.state.selectOptions}
                    isMulti
                    name="colors"
                    onChange={this.handleChange}
                    options={this.props.tagsList}
                    className="basic-multi-select"
                    classNamePrefix="select"
                    getOptionLabel={option => option['displayName']}
                    getOptionValue={option => option['id']}
                    styles={this.customStyles}
                    theme={this.customTheme}
                    placeholder="Select tags"
                    isSearchable={false}
                    maxMenuHeight={190}
                />
            )
        } else {
            return null;
        }
    }
}

function mapStateToProps(state) {
    return {
        tagsList: state.presentations.present.tagsList,
        presentationTagsFilter: state.presentations.present.presentationTagsFilter,
        loggedIn: state.users.loggedIn,
        role: state.users.role,
        email: state.users.email,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        ...bindActionCreators({ logoutUser, applyFilter, showPopup, getTags, applyTagsFilter }, dispatch)
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(TagsSelect))